<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" md="12">
        <div class="text-h4">{{ team.name }}</div>
        <div v-if="myReg?.isRegistered()">Registered as {{ myReg.teamLevel?.team_level }}</div>
        <div v-else>Not Registered</div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6" class="mb-6">
        <TeamLeaderCompontent :teamLeader="teamLeader"></TeamLeaderCompontent>
      </v-col>
      <v-col cols="12" md="6" class="mb-6">
        <TeamLogoCompontent
          :team="team"
          @logoUpdated="handleLogoUpdated"
          @snack="throwSnack"></TeamLogoCompontent>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card
          title="Team Info"
          subtitle="This info (website/socials/bio etc) may appear on 72Fest.com">
          <template v-slot:append>
            <v-btn variant="text" icon @click="isTeamEdit = !isTeamEdit">
              <v-icon icon="mdi-pencil">
                <v-tooltip activator="parent" location="end">Edit Team</v-tooltip>
              </v-icon>
            </v-btn>
          </template>
          <v-card-text v-if="!isTeamEdit">
            <TeamViewComponent :team="team"></TeamViewComponent>
          </v-card-text>
          <TeamEditComponent
            v-if="isTeamEdit"
            :team="team"
            :isCreate="false"
            :allow-close="true"
            @teamEditComplete="handleTeamEditComplete"
            @team-edit-canceled="isTeamEdit = false"
            @snack="throwSnack">
          </TeamEditComponent>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script setup lang="ts">
import { ref, computed } from 'vue';
import { useTeamStore, useYearStore } from '@/stores/index';

import { ITeamCriteriaDTO, TeamDTO, UserDTO } from '@/dtos';
import TeamEditComponent from '@/components/teams/TeamEditComponent.vue';
import TeamViewComponent from '@/components/teams/TeamViewComponent.vue';
import TeamLeaderCompontent from '@/components/teams/TeamLeaderCompontent.vue';
import TeamLogoCompontent from '@/components/teams/TeamLogoCompontent.vue';
import { SNACKSTATUS } from '@/stores/util';
import { useSnack } from '@/helpers';
const emit = defineEmits<{
  (e: 'snack', objType: string, snackType: SNACKSTATUS, err?: string): void;
}>();
const { throwSnack } = useSnack(emit);
const props = defineProps<{ reg: ITeamCriteriaDTO }>();
const teamStore = useTeamStore();
const yearStore = useYearStore();

const team = computed(() => {
  return teamStore.myTeam ? teamStore.myTeam : new TeamDTO();
});

const teamId = computed(() => team.value.id);
const yearId = computed(() => yearStore.selectedYearId);
const isTeamEdit = ref(false);

const myReg = computed(() => props.reg);

const { data: leaderData } = teamStore.getTeamLeadQuery(teamId, yearId);
const teamLeader = computed(() => leaderData.value ?? new UserDTO());

const handleLogoUpdated = async () => {
  await teamStore.forceTeamUpdate();
};

const handleTeamEditComplete = () => {
  isTeamEdit.value = false;
};
</script>
